<div class="support-faq-answer">
  <ng-container *ngFor="let block of blocks; trackBy: trackBlock">
    <p *ngIf="block.type === 'paragraph'" class="support-faq-answer__paragraph">
      <ng-container *ngFor="let part of block.parts; trackBy: trackPart">
        <span *ngIf="part.type === 'text'">{{ part.value }}</span>
        <strong *ngIf="part.type === 'bold'">{{ part.value }}</strong>
        <a
          *ngIf="part.type === 'link'"
          class="support-faq-answer__link"
          [href]="part.href"
          [attr.target]="isExternalLink(part.href) ? '_blank' : null"
          [attr.rel]="isExternalLink(part.href) ? 'noopener noreferrer' : null">
          {{ part.label }}
        </a>
      </ng-container>
    </p>

    <p *ngIf="block.type === 'list-item'" class="support-faq-answer__list-item">
      <span class="support-faq-answer__bullet" aria-hidden="true">•</span>
      <span class="support-faq-answer__list-item-content">
        <ng-container *ngFor="let part of block.parts; trackBy: trackPart">
          <span *ngIf="part.type === 'text'">{{ part.value }}</span>
          <strong *ngIf="part.type === 'bold'">{{ part.value }}</strong>
          <a
            *ngIf="part.type === 'link'"
            class="support-faq-answer__link"
            [href]="part.href"
            [attr.target]="isExternalLink(part.href) ? '_blank' : null"
            [attr.rel]="isExternalLink(part.href) ? 'noopener noreferrer' : null">
            {{ part.label }}
          </a>
        </ng-container>
      </span>
    </p>
  </ng-container>
</div>
